import {
  CasEntityRHFSelect,
  CasEntitySelect,
  componentProps,
  CasEntitySelectProps,
} from 'src/compass/shared/components';
import { useRetrieveSelectListOptions } from 'src/compass/shared/components/CasSelect/CasEntitySelect';
import { EntityListOptionsProps } from 'src/compass/shared/hooks/reactQuery/useRetrieveEntityListOptions';

const entity = 'Employee/Select';

export function useEmployeeOptions(props: EntityListOptionsProps) {
  return useRetrieveSelectListOptions(entity, props);
}

export function CasRHFEmployeeSelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect(entity, props);
}

export function CasEmployeeSelect(props: componentProps) {
  return CasEntitySelect(entity, props);
}
